<template>
  <div class="error" v-if="label">
    <font-awesome-icon icon="exclamation-circle"/> {{label}}
  </div>
</template>

<script setup lang="ts">
interface Props {
  label?: string;
}

withDefaults(defineProps<Props>(), {
  label: ''
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.error {
  margin:20px 0;
  color: red;
  font-weight: bold;
}
</style>